import type { LocaleCode } from "./locale-config";

export const accessibilityCopy: Record<
  LocaleCode,
  { skip: string; home: string; primaryNavigation: string; mobileNavigation: string }
> = {
  "en-ca": {
    skip: "Skip to content",
    home: "home",
    primaryNavigation: "Primary navigation",
    mobileNavigation: "Mobile navigation",
  },
  "zh-cn": {
    skip: "跳到主要内容",
    home: "首页",
    primaryNavigation: "主导航",
    mobileNavigation: "移动导航",
  },
  "zh-tw": {
    skip: "跳至主要內容",
    home: "首頁",
    primaryNavigation: "主要導覽",
    mobileNavigation: "行動版導覽",
  },
  "pa-in": {
    skip: "ਮੁੱਖ ਸਮੱਗਰੀ ਤੇ ਜਾਓ",
    home: "ਮੁੱਖ ਪੰਨਾ",
    primaryNavigation: "ਮੁੱਖ ਨੇਵੀਗੇਸ਼ਨ",
    mobileNavigation: "ਮੋਬਾਈਲ ਨੇਵੀਗੇਸ਼ਨ",
  },
  "ko-kr": {
    skip: "본문으로 건너뛰기",
    home: "홈",
    primaryNavigation: "주요 탐색",
    mobileNavigation: "모바일 탐색",
  },
  "fa-ir": {
    skip: "پرش به محتوای اصلی",
    home: "صفحهٔ اصلی",
    primaryNavigation: "ناوبری اصلی",
    mobileNavigation: "ناوبری موبایل",
  },
  "ar-sa": {
    skip: "تخطّي إلى المحتوى الرئيسي",
    home: "الصفحة الرئيسية",
    primaryNavigation: "التنقّل الرئيسي",
    mobileNavigation: "تنقّل الجوال",
  },
};
